document.addEventListener('DOMContentLoaded', () => {
    const finalTime = $('.final_time').data('time')
    console.log(finalTime)
    const options = {timeZone: 'America/New_York'};
    const countDownDate = new Date(new Date().toLocaleString('en-US',options));
    countDownDate.setHours(finalTime.split(":")[0], 0, 0, 0)
    console.log(countDownDate)
    function calculateDate () {
        var now = new Date().getTime();
        var timeleft = countDownDate - now;
      console.log(timeleft)
        if (timeleft < 0) {
            clearInterval(myfunc);
            document.querySelector('.order_in_section').classList.add('hidden')
        } else {
          var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          const finalString = `${hours}h ${minutes}m`
          $('.order_in_section .counter').text(finalString)   
        }      
    }
    calculateDate()
    var myfunc = setInterval(calculateDate, 10000)
})

